import { render, staticRenderFns } from "./ProjectPermissions.vue?vue&type=template&id=94096468&scoped=true&"
import script from "./ProjectPermissions.vue?vue&type=script&lang=js&"
export * from "./ProjectPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPermissions.vue?vue&type=style&index=0&id=94096468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94096468",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VDataTable,VIcon,VLayout,VListItemContent,VSelect,VTooltip})
